import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import Header from '../../../components/Header'
import HeaderOXL from '../../../components/PerfilOxetechLab/Header'
// import HeaderEmpresa from '../../../components/HeaderEmpresa'

import Siderbar from '../../../components/Siderbar'

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import {
  ContentSider,
  ContentHeader,
  WrapperSider,
  WrapperHeader,
  Background
} from './styles'

function DefaultLayout({ children, profile }) {
  if (profile) {
    return (
      <Container disableGutters maxWidth={false}>
        {/* Header global (SECTI azul + OXETECH laranja) é renderizado em TODAS
            as telas autenticadas — fica `position: fixed` no topo. AppSidebars
            (DashboardAluno, SidebarAdmin, PerfilOxetechLab) usam
            `top: var(--app-header-height)` para começar abaixo dele.
            O paddingTop do Box compensa o Header fixed para que o conteúdo
            não comece atrás dele. */}
        <Header profile={profile} />
        {/* Fallback `calc(5vh + 64px)` cobre a altura natural do Header
            (HeaderSectiDash 5vh + Toolbar MUI default 64px) caso a CSS var
            ainda não tenha sido medida no primeiro paint. */}
        <Box
          sx={{
            paddingTop: "var(--app-header-height, calc(5vh + 64px))",
          }}
        >
          {children}
        </Box>
      </Container>
    )
  } else {
    return (
      <WrapperSider>
        <Background>{children}</Background>
      </WrapperSider>
    )
  }
}

export default connect(state => ({ profile: state.user?.profile }))(
  DefaultLayout
)
DefaultLayout.propTypes = {
  children: PropTypes.element.isRequired
}
